import React from "react";
import AppRouter from "./route";
import { Provider } from "react-redux";
import { store } from "./store/index";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import GlobalToastManager from "@/components/Toast/GlobalToastManager";
import NavigationToastHandler from "@/components/Toast/NavigationToastHandler";
// Removed app-specific MUI theme wrapper; using SharedComponentsThemeProvider in main.tsx

const App: React.FC = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Provider store={store}>
        <AppRouter />
        <NavigationToastHandler />
        <GlobalToastManager />
      </Provider>
    </LocalizationProvider>
  );
};

export default App;
